import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = { class: "flex alignC" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_5 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center","padding":"20px 0"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "VIN" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.vin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.vin = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "所属单位" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.units_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.units_id = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.repairunitData, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.repair_unit_name,
                      value: item.repair_unit_id,
                      key: item.repair_unit_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "车主姓名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.master_name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.master_name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "车主身份证" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.idcard,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.idcard = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "品牌车型" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "mar-r-8",
                modelValue: _ctx.form.car_brand_id,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.car_brand_id = $event)),
                style: {"width":"108px"},
                filterable: "",
                placeholder: "请选择",
                onChange: _ctx.selectCarBrandChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.car_brand_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.brand_name,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"]),
              _createVNode(_component_el_select, {
                class: "mar-r-18",
                modelValue: _ctx.form.car_series_id,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.car_series_id = $event)),
                placeholder: "请选择",
                style: {"width":"132px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.car_series_data, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.series_name,
                      value: item.id,
                      key: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "车身颜色" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.body_color,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.body_color = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "车主手机" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.car_master_phone,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.car_master_phone = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "发动机号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.engine_number,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.engine_number = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "保养里程" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.maintenance_mileage,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.maintenance_mileage = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "购车时间" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                style: {"width":"368px"},
                modelValue: _ctx.form.purchase_time_text,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.purchase_time_text = $event)),
                type: "date",
                placeholder: "选择日期",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveCarInfoChange($event,'purchase_time')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "下次保养" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "input-wid",
                modelValue: _ctx.form.nm_time_text,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.nm_time_text = $event)),
                placeholder: "请选择下次保养时间",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveCarInfoChange($event,'nmtime')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "年检到期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "input-wid",
                modelValue: _ctx.form.aidue_text,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.aidue_text = $event)),
                placeholder: "请选择年检到期时间",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveCarInfoChange($event,'aidue')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "商业险到期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "input-wid",
                modelValue: _ctx.form.ccidue_text,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.ccidue_text = $event)),
                placeholder: "请选择商业险到期时间",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveCarInfoChange($event,'ccidue')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "商业险公司" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.cicompany_id,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.cicompany_id = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cicompanyData, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.basicset_name,
                      value: item.basicset_id,
                      key: item.basicset_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "商业险保单号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.cipnumber,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.cipnumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "交强险到期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "input-wid",
                modelValue: _ctx.form.compulsory_insurance_due_text,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.compulsory_insurance_due_text = $event)),
                placeholder: "请选择交强险到期时间",
                onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.saveCarInfoChange($event,'compulsory_insurance_due')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "交强险公司" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"368px"},
                modelValue: _ctx.form.jicompany_id,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.form.jicompany_id = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cicompanyData, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.basicset_name,
                      value: item.basicset_id,
                      key: item.basicset_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "交强险保单号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.dipolicy_no,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.dipolicy_no = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "接车提示" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"368px"},
                modelValue: _ctx.form.tips,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.tips = $event)),
                type: "textarea",
                rows: 2
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}